import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ApparelProvider } from './context/FlowContext';

const el = document.getElementById('reactOrderFlowWidget');
const root = ReactDOM.createRoot(el);
const searchParams = new URLSearchParams(window.location.search);
const sport = searchParams.get('sport');
const variant = searchParams.get('variant');
root.render(
  <React.StrictMode>
    <ApparelProvider>
      <App envParam={sport || el.getAttribute('data-param')} variant={variant} />
    </ApparelProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
